import { useAuth } from './useAuth.js';

// بوابة الوصول لكل نوع مخزن — تطابق مفاتيح الصلاحيات في الخادم.
export const WAREHOUSE_TYPE_PERM = {
  cafeteria: 'inventory.cafeteria',
  toys: 'inventory.toys',
  general: 'inventory.general'
};

// تصفية المخازن حسب صلاحيات المستخدم (فصل الكافتيريا عن الألعاب).
// التقييد اختياري: من لا يملك أي بوابة مخزن يرى كل المخازن (توافق رجعي).
export function filterAllowedWarehouses(warehouses, hasPermission) {
  if (!Array.isArray(warehouses)) return [];
  const granted = Object.keys(WAREHOUSE_TYPE_PERM).filter((t) => hasPermission(WAREHOUSE_TYPE_PERM[t]));
  if (granted.length === 0) return warehouses;
  return warehouses.filter((w) => {
    const perm = WAREHOUSE_TYPE_PERM[w.type];
    if (!perm) return true; // نوع غير معروف → لا نُقيّده
    return hasPermission(perm);
  });
}

// هوك يعيد المخازن المسموح بها للمستخدم الحالي.
export function useAllowedWarehouses(warehouses) {
  const hasPermission = useAuth((s) => s.hasPermission);
  return filterAllowedWarehouses(warehouses || [], hasPermission);
}
